<template>
  <div>
    <layout-default>
      <div class="container mb-4">
        <breadcrumb class="mt-5">
          <link-wrapper
            location="/"
            class="breadcrumb-text text-decoration-none"
          >
            <span class="breadcrumb-home">Inicio</span>
            <span class="breadcrumb-text mx-2"> / </span>
          </link-wrapper>
          <link-wrapper
            location="/admin/auctions"
            class="breadcrumb-text text-decoration-none"
          >
            <span class="breadcrumb-home">Remates</span>
            <span class="breadcrumb-text mx-2"> / </span>
          </link-wrapper>
        </breadcrumb>
      </div>
      <div class="mt-5">
        <section class="container col-10 products">
          <div class="d-flex justify-content-center">
            <!-- Card Info Group -->
            <card class="mx-auto">
              <template v-slot:title>
                <b>
                  {{ $route.params.id ? "Editar Remate" : "Nuevo Remate" }}
                </b>
              </template>
              <template v-slot:body>
                <auction-form :auction-slug="$route.params.id" type="editar" />
              </template>
            </card>
          </div>
        </section>
      </div>
    </layout-default>
  </div>
</template>

<script>
import Card from "@/components/molecules/Card/Card.vue";
import Breadcrumb from "@/components/atoms/Breadcrumb/Breadcrumb.vue";
import LayoutDefault from "@/components/organisms/LayoutDefault/LayoutDefault.vue";
import AuctionForm from "@/components/custom/auction/form.vue";
import LinkWrapper from "@/components/atoms/LinkWrapper/LinkWrapper.vue";

export default {
  name: "AdminProductsNew",
  middleware: ["auth", "admin"],
  components: {
    AuctionForm,
    LayoutDefault,
    Card,
    Breadcrumb,
    LinkWrapper,
  },
  mounted() {
    this.$store.commit("setLocation", [
      {
        title: "Editar Remate",
        location: `/admin/auctions/edit/${this.$route.params.id}`,
      },
    ]);
  },
};
</script>
